module.exports = __webpack_public_path__ + "media/images/athletes/1857-8464805fab8ae33fd1172b761f54584f.png";